<template>
  <v-dialog :value="dialogProp.show" persistent max-width="600">
    <v-card class="elevation-12">
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t('Получатели') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pt-3">
        <v-row>
          <v-col>
            <ValidationObserver ref="emails">
              <validatable-mail-list
                  v-model="emails"
                  rules="required"
                  :label="$t('Адрес электронной почты')" />
            </ValidationObserver>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="continueBtn"
            v-test="{ btn: 'continue' }"
            color="primary"
            @click.stop="continueOperation">
          {{ $t('Продолжить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import ValidatableMailList from '@/components/reused/ui/ValidatableMailList.vue'

  export default {
    components: {
      ValidatableMailList
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            item: [],
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        emails: []
      }
    },
    computed: {
      color () {
        return this.warning
          ? 'warning'
          : 'primary'
      }
    },
    watch: {
      dialogProp: {
        immediate: true,
        deep: true,
        handler: function (newValue) {
          this.emails = newValue?.item?.emails || []
        }
      }
    },
    methods: {
      continueOperation: async function () {
        const result = await this.$refs.emails.validate()
        if (!result) {
          return
        }
        try {
          if (this.dialogProp.callback) {
            await this.dialogProp.callback({
              ...this.dialogProp.item,
              emails: this.emails
            })
          }
        } catch (error) {
          this.throwIfNotServerError(error)
        }
        this.cancel()
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
